var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCircleWithWhiteCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_wrong_2494788") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions/New",
    transform: "translate(-1191.000000, -1739.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(51.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statement-Copy-2",
    transform: "translate(40.000000, 1589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    transform: "translate(399.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(256.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(17.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_wrong_2494788",
    transform: "translate(88.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7708645,1.08657519 C17.446782,-1.59475012 8.98739433,0.81978682 4.09788683,6.8593383 C-0.735251932,12.8292832 -1.37009462,21.4473563 2.60351693,28.0410454 C6.57703756,34.6344362 14.3310848,38.061363 21.8808547,36.7078139 C30.6656107,35.1329074 36.8268119,27.2832571 37,18.5071165 C36.8467155,10.7413629 32.1260369,3.7791839 24.7708645,1.08657519 Z M26.0778562,27.8518877 C23.5519224,25.3255701 21.0259907,22.7993023 18.5000072,20.2730364 C15.9740237,22.7993023 13.44809,25.3255701 10.9221572,27.8518877 C9.77933018,28.994865 8.00707545,27.2213734 9.14940132,26.0788973 C11.6753341,23.5525798 14.2012678,21.026312 16.7272513,18.500046 C14.2012678,15.9737285 11.6753342,13.4474606 9.14940137,10.9211441 C8.00657433,9.77821561 9.77983229,8.00567673 10.9221573,9.14815369 C13.44809,11.6744703 15.9740237,14.2007381 18.5000072,16.7270041 C21.0259907,14.2007381 23.5519225,11.6744703 26.0778562,9.14815369 C27.2206823,8.0051755 28.992937,9.77866705 27.8506121,10.9211441 C25.3246784,13.4474606 22.7987466,15.9737285 20.2727631,18.5000461 C22.7987466,21.026312 25.3246784,23.5525798 27.8506121,26.0788974 C28.9934381,27.2218248 27.2201811,28.9943637 26.0778562,27.8518877 Z",
    id: "Shape",
    fill: "#FF6947",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0778562,27.8518877 C23.5519224,25.3255701 21.0259907,22.7993023 18.5000072,20.2730364 C15.9740237,22.7993023 13.44809,25.3255701 10.9221572,27.8518877 C9.77933018,28.994865 8.00707545,27.2213734 9.14940132,26.0788973 C11.6753341,23.5525798 14.2012678,21.026312 16.7272513,18.500046 C14.2012678,15.9737285 11.6753342,13.4474606 9.14940137,10.9211441 C8.00657433,9.77821561 9.77983229,8.00567673 10.9221573,9.14815369 C13.44809,11.6744703 15.9740237,14.2007381 18.5000072,16.7270041 C21.0259907,14.2007381 23.5519225,11.6744703 26.0778562,9.14815369 C27.2206823,8.0051755 28.992937,9.77866705 27.8506121,10.9211441 C25.3246784,13.4474606 22.7987466,15.9737285 20.2727631,18.5000461 C22.7987466,21.026312 25.3246784,23.5525798 27.8506121,26.0788974 C28.9934381,27.2218248 27.2201811,28.9943637 26.0778562,27.8518877 Z",
    id: "Path",
    fill: "#ECF6E8"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircleWithWhiteCross);
export default __webpack_public_path__ + "static/media/red-circle-with-white-cross.820570a1426074275f09b2199f2645e3.svg";
export { ForwardRef as ReactComponent };